<template>
	<div class="news-card" :class="{ 'news-card--card': card }">
		<div class="news-card__content">
			<nuxt-link :to="localePath({ name: 'blog-newsTitle', params: { newsTitle: [post.slug ?? ''] } })" class="news-card__image-container">
				<GlobalImage v-if="topImage" class="news-card__image" :alt="post.title" :src="storageUrl + topImage" :height="220" />
				<GlobalImage v-else class="news-card__image" src="news_placeholder.png" alt="News placeholder" :height="220" />
			</nuxt-link>
			<div class="news-card__date-and-title">
				<div class="news-card__date">{{ format(new Date(post.publishedAt), 'dd.MM.yyyy') }}</div>
				<nuxt-link :to="localePath({ name: 'blog-newsTitle', params: { newsTitle: [post.slug ?? ''] } })" class="news-card__title">{{
					post.title
				}}</nuxt-link>
				<ul v-if="post.categories && post.categories.length > 0" class="news-card__categories">
					<li v-for="category in post.categories" :key="category.id" class="news-card__category">
						<nuxt-link
							:to="localePath({ name: 'blog-newsTitle', params: { newsTitle: [category.slug] } })"
							class="news-card__category-link"
							>{{ category.name }}</nuxt-link
						>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { format } from 'date-fns'
const localePath = useLocalePath()
const { storageUrl } = useStorageService()

const props = defineProps<{
	post: Partial<INewsModel>
	card?: boolean
}>()

const topImage = computed(() => {
	const file = props.post.files?.find((f) => f.collection === EFileCollection.NEWS_TOP_IMAGE)
	return file ? file.path : null
})
</script>

<style lang="scss" scoped src="./Card.scss"></style>
